// External GoDaddy pay link (the real destination)
export const GODADDY_DONATE_URL = "https://6a8ed2bc-cd0c-45d4-9356-d99698eaf2a0.paylinks.godaddy.com";

// Branded, shareable link on our own domain. Counts the click, then redirects to GoDaddy.
// This is what every "Donate" button uses.
export const DONATE_URL = "/give";

// Official X (Twitter) profile.
export const X_URL = "https://x.com/realPPUSA";
